// import React,{ useRef } from 'react'
// import * as THREE from 'three'
// import { useThree } from "react-three-fiber"
import { WEBGL } from 'three/examples/jsm/WebGL.js'

import {observable, action} from 'mobx'

class AppStore {
    @observable isWebGl = WEBGL.isWebGLAvailable()
    @observable currentScrollTop = 0

    @observable isLoadedModelData = false
    @observable isLoaded = false
    @observable isLoadedAnimated = false
    @observable isLoadedParticleAnimated = false
    @observable isLoadedWebGl = false

    @observable isFirstIntro = false
    @observable isFirstIntroFix = false

    @observable transitionCurrent = "none"

    @observable isOpenModalMenu = false

    @observable careerSubject = ""
}

export default AppStore